import styled from "styled-components"
import { tabletSize, mobileSize, userSelect, colors } from "../constants"
import assetPrefix from "../utils/assetPrefix"

export const PackageTitle = styled.div`
  font-size: 30px;
  font-weight: bold;
  color: ${colors.black};
  margin-bottom: 10px;
  transition: font-size 0.3s ease-in, margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 24px;
    margin-bottom: 6px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 20px;
    margin-bottom: 5px;
  }
`

export const PackagePeriod = styled(PackageTitle)`
  font-size: 24px;
  transition: font-size 0.3s ease-in, margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 20px;
    margin-bottom: 5px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 17px;
  }
`

export const PackagePrice = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;

  -webkit-transition: margin-bottom 0.3s ease-in, font-size 0.3s ease-in;
  -moz-transition: margin-bottom 0.3s ease-in, font-size 0.3s ease-in;
  -o-transition: margin-bottom 0.3s ease-in, font-size 0.3s ease-in;
  transition: margin-bottom 0.3s ease-in, font-size 0.3s ease-in;

  @media (max-width: ${tabletSize}) {
    font-size: 16px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 14px;
  }
`

export const OrangeText = styled.span`
  font-weight: bold;
  color: ${colors.ligh_blood_orange};
`

export const GreyText = styled.span`
  color: #9e9e9e;
  padding: 0 2px;
  &:last-of-type {
    display: none;
  }
`

export const PriceNotice = styled.div`
  font-size: 14px;
  color: ${colors.greyish_brown};
  margin-top:8px
  margin-bottom: 0;
  transition: font-size 0.3s ease-in, margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 14px;
    margin-top:7px
    margin-bottom: 0;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 12px;
    margin-top:5px;
  }
`

export const FairNameNotice = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.greyish_brown};
  border-left: 1px solid ${colors.ligh_blood_orange};
  padding-left: 8px;
  margin-top: 8px;
  transition: font-size 0.3s ease-in, margin-top 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 15px;
    margin-top: 7px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 14px;
    margin-top: 5px;
  }
`

export const GreyShadowLine = styled.div`
  width: 100%;
  margin-top: 30px;
  border-bottom: 1px solid ${colors.very_light_pink_five};
  padding-bottom: 12px;
  @media (max-width: ${tabletSize}) {
    margin-top: 34px;
  }
  @media (max-width: ${mobileSize}) {
    margin-top: 18px;
  }
`

export const PackageDetailTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 11px;
  border-bottom: 2px solid ${colors.dark_orange};
  transition: font-size 0.3s ease-in;
  // @media (max-width: ${tabletSize}) {
  //   margin-top: 
  // }
  @media (max-width: ${mobileSize}) {
    font-size: 14px;
  }
`
export const PackageDetailList = styled.li`
  font-size: 16px;
  margin-bottom: 20px;
  color: ${colors.slate_grey};
  transition: font-size 0.3s ease-in, margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 16px;
    margin-bottom: 19px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 14px;
    margin-bottom: 16px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`
export const PackageDetailText = styled.div`
  font-size: 16px;
  margin-bottom: 20px;
  color: ${colors.slate_grey};
  transition: font-size 0.3s ease-in, margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    font-size: 16px;
    margin-bottom: 19px;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 14px;
    margin-bottom: 16px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  ul {
    padding-left: 20px !important;
  }
`

export const ViewMore = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-top: 4px;
  color: ${colors.blood_orange};
  cursor: pointer;
  ${userSelect}
  @media (max-width: ${tabletSize}) {
    font-size: 16px;
    margin-top: 20px;
  }
  @media (max-width: ${mobileSize}) {
    margin-top: 18px;
    font-size: 14px;
  }
`
export const OrangeArrow = styled.img.attrs({
  src: `${assetPrefix}/images/ic-btn-arrow-next-orange@3x.png`,
  alt: "Orange Arrow Icon"
})`
  width: 7px;
  height: 10px;
  margin: 0 5px;
`
